import type { GeoLocation } from '@smg-real-estate/geo-libs';

import {
  type AgentSearchFacets,
  isSameAgentSearchFacets,
} from '@/helpers/AgentDirectory/agentFacetRouteParams';
import { haveSameSearchedGeoIds } from '@/stores/geoLocationHelpers';

export interface AgentSearchIdentity {
  resolvedLocations: GeoLocation[];
  currentPage: number;
  searchedLocations: GeoLocation[] | null | undefined;
  loadedPage: number;
  facets: AgentSearchFacets;
  searchedFacets: AgentSearchFacets;
}

/** True when resolved locations, page, and facets match the already-loaded agent search. */
export const isSameAgentSearch = ({
  resolvedLocations,
  currentPage,
  searchedLocations,
  loadedPage,
  facets,
  searchedFacets,
}: AgentSearchIdentity): boolean => {
  if (currentPage !== loadedPage) {
    return false;
  }

  if (!isSameAgentSearchFacets(facets, searchedFacets)) {
    return false;
  }

  return haveSameSearchedGeoIds(searchedLocations, resolvedLocations);
};
